import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { APP_DEFAULT_PATH } from 'config';

export default function DeveloperProtectedRoutes({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user || (user.role !== 'developer' && user.role !== 'super-admin')) {
    // Redirect non-developers and non-super-admins to default app path
    return <Navigate to={APP_DEFAULT_PATH} state={{ from: location }} replace />;
  }
  return children;
}

DeveloperProtectedRoutes.propTypes = {
  children: PropTypes.node
};
